"use client";

import { useEffect } from "react";
import { useUIStore } from "@/core/state/ui-store";

/**
 * ResponsiveProvider handles the synchronization between the browser viewport
 * and the global UI Zustand store.
 *
 * It should be rendered once at the root level of your application layout.
 */
export function ResponsiveProvider({ children }: { children: React.ReactNode }) {
  const setViewport = useUIStore((state) => state.setViewport);

  useEffect(() => {
    // Initial sync
    setViewport(window.innerWidth);

    // Optimized resize listener
    let timeoutId: number | null = null;

    const handleResize = () => {
      if (timeoutId) window.clearTimeout(timeoutId);

      // Debounce to prevent excessive store updates during smooth resizing
      timeoutId = window.setTimeout(() => {
        setViewport(window.innerWidth);
      }, 100) as unknown as number;
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (timeoutId) window.clearTimeout(timeoutId);
    };
  }, [setViewport]);

  return <>{children}</>;
}
